import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Chip } from "@mui/material";

const checkIcon = <CheckCircleIcon sx={{ ml: 0.5, mr: 2 }} color="success" />;

const crossIcon = <CancelIcon sx={{ ml: 0.5, mr: 2 }} color="error" />;

const iconSwitch = (status) => {
  switch (status) {
    case true:
      return checkIcon;
    case false:
      return crossIcon;
    default:
  }
};

export function CustomMUIChip({ label, variant, status, color }) {
  return (
    <Chip
      icon={iconSwitch(status)}
      label={label}
      variant={variant}
      color={color}
    />
  );
}
